// Rummy — single card render. Pure display; interactivity (click,
// drag) is owned by HandStrip via pointer events on the parent.

export type CardData = {
  id: string;
  rank: 'A'|'2'|'3'|'4'|'5'|'6'|'7'|'8'|'9'|'10'|'J'|'Q'|'K'|'JOKER';
  suit: 's'|'h'|'c'|'d'|'joker';
  printedJoker?: boolean;
  value?: number;
};

const SUIT_GLYPH: Record<string, string> = {
  s: '♠', h: '♥', c: '♣', d: '♦', joker: '🃏',
};

function colorClass(card: CardData) {
  if (card.suit === 'h' || card.suit === 'd') return 'red';
  return 'black';
}

export default function Card({
  card, selected, wild, onPointerDown,
}: {
  card: CardData;
  selected?: boolean;
  wild?: boolean;
  onPointerDown?: (e: React.PointerEvent) => void;
}) {
  const isJoker = card.suit === 'joker' || card.rank === 'JOKER';
  return (
    <div
      id={card.id}
      onPointerDown={onPointerDown}
      className={[
        'rummy-card',
        colorClass(card),
        selected ? 'rummy-card--selected' : '',
        wild ? 'rummy-card--wild-badge' : '',
      ].filter(Boolean).join(' ')}
    >
      <div className="rummy-card__corner rummy-card__corner--tl">
        <span>{isJoker ? '🃏' : card.rank}</span>
        {!isJoker && <span>{SUIT_GLYPH[card.suit]}</span>}
      </div>
      <div className="rummy-card__suit-lg">
        {isJoker ? '🃏' : SUIT_GLYPH[card.suit]}
      </div>
      <div className="rummy-card__corner rummy-card__corner--br">
        <span>{isJoker ? '🃏' : card.rank}</span>
        {!isJoker && <span>{SUIT_GLYPH[card.suit]}</span>}
      </div>
    </div>
  );
}
